export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";